import '../stylesheets/crossword.scss'
import '../../../node_modules/codemirror/lib/codemirror.css';

window.components = {
  ...window.components,
  'CrosswordEditor': require('../components/CrosswordEditor'),
  'Stopwatch': require('../components/Stopwatch')
}

window.mountComponents(window.components);
